import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import PropTypes from "prop-types";
import ReveCardHistory from '../../components/TransferDrawer/TransferDrawerComponents/ReveCardHistory/ReveCardHistory';
import ReveCardApproval from '../../components/TransferDrawer/TransferDrawerComponents/ReveCardApproval';
import { useSelector } from 'react-redux';
import PhysicalCardCreation from '../../components/PhysicalCardCreation/PhysicalCardCreation';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          // overflow: "hidden",
        }}
        // sx={{ overflow: "hidden" }}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </Box>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

const CardServices = () => {

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    let configVariables = useSelector((state) => state.config.baseConfig);

    useEffect(() => {
    setValue(0);
    }, []);

    return (
        <Box className="page-container">

            <Box>
                <Box className={`page-title`}>
                    <Box className="crm-row-style">
                    <Box className="padding-header">Card Services</Box>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: "#f8f8f8", position: "sticky", top: 0, zIndex: 1 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={{
                    "& .MuiTab-root": {
                        textTransform: "capitalize",
                        color: "#BCBCBC",
                        fontFamily: "Inter",
                        fontSize: 15,
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "30px",
                        backgroundColor: "#f8f8f8",
                        "&.Mui-selected": {
                        backgroundColor: "white",
                        color: "#00365A",
                        borderRadius: "6px 6px 0 0 !important",
                        textAlign: "center",
                        fontSize: 15,
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "30px",
                        borderBottom: 0,
                        borderBottomColor: "#FAC800",
                        borderBottomWidth: 4,
                        },
                    },
                    }}
                >
                    <Tab
                        label={`${configVariables?.clientKeyword1} Card History`}
                        {...a11yProps(0)}
                    />

                    <Tab
                        label={`${configVariables?.clientKeyword1} Card Approval`}
                        {...a11yProps(0)}
                    />

                    {/* <Tab
                        label={`Card Creation`}
                        {...a11yProps(0)}
                    /> */}
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <ReveCardHistory />
            </CustomTabPanel>
            
            <CustomTabPanel value={value} index={1}>
                <ReveCardApproval />
            </CustomTabPanel>

            {/* <CustomTabPanel value={value} index={2}>
              <PhysicalCardCreation />
            </CustomTabPanel> */}
        </Box>
    );
};

export default CardServices;
